if (!customElements.get('component-hero')) {
  class ComponentHero extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.data = this.querySelector('[id*="Section-Component-Hero-Data-"]');
      const slider = this.closest('.swiper');
      if (slider) {
        return;
      }
      this.init();
    }

    init() {
      this.holders = this.querySelectorAll('[data-rotating-text]');

      if (!this.data || !this.holders) return;

      try {
        this.phrases = JSON.parse(this.data.textContent);

        this.holders.forEach((holder) => {
          carousel(this.phrases, holder);
        });

        this.classList.add('is-initialized');
      } catch (error) {
        console.error(error.message);
      }
    }
  }

  customElements.define('component-hero', ComponentHero);
}
